export default "<app-header></app-header>\n<div class=\"container main\">\n    <router-outlet></router-outlet>\n</div>\n<app-footer></app-footer>\n\n";